import React from "react";

import OkCSSLoader from "../OkCSSLoader";
import OkcLoader from "../OkcLoader";
import { isDesktop } from "shared/util/EnvironmentHelpers";

import "./index.scss";

const PageLoading = () => (
	<div className="page-loading">
		{isDesktop
			? <OkcLoader />
			: <OkCSSLoader show />}
	</div>
);

export default PageLoading;



// WEBPACK FOOTER //
// ./src/shared/components/PageLoading/index.jsx